export { default as Icon } from './Icon';
export type { IconProps, IconName, IconVariant } from './types';
